
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree6a0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree6a0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("45jfr", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $2f968f4aebb5efd7$export$6503ec6e8aabbaf; }, function (v) { return $2f968f4aebb5efd7$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $2f968f4aebb5efd7$export$f7ad0328861e2f03; }, function (v) { return $2f968f4aebb5efd7$export$f7ad0328861e2f03 = v; });
var $2f968f4aebb5efd7$export$6503ec6e8aabbaf;
var $2f968f4aebb5efd7$export$f7ad0328861e2f03;
"use strict";
var $2f968f4aebb5efd7$var$mapping = new Map();
function $2f968f4aebb5efd7$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$2f968f4aebb5efd7$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $2f968f4aebb5efd7$var$resolve(id) {
    var resolved = $2f968f4aebb5efd7$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$2f968f4aebb5efd7$export$6503ec6e8aabbaf = $2f968f4aebb5efd7$var$register;
$2f968f4aebb5efd7$export$f7ad0328861e2f03 = $2f968f4aebb5efd7$var$resolve;

});

var $2b267f3a0b2c898e$exports = {};

(parcelRequire("45jfr")).register(new URL("", import.meta.url).toString(), JSON.parse('["3Cvrd","index.e903d4f4.js","5ZTy3","about.4d32353c.js","4nyur","sandbox-override.f4f24a23.js","4orrb","disclaimer.bc82a111.js","5XeKV","custom.26e66670.js","ipP99","aparam.030d0f19.js","fEFKC","gpmimergdaily.74e07d12.png","btpZZ","GPM_3IMERGDF.data.d5c73da4.js","cpsye","tropess_tcr_optimized_news.dc3f255a.jpg","8WZnw","TROPESS_NOx.data.a9a065e6.js","e9pXz","TROPESS_O3.9e797fb6.jpg","ihwbm","TROPESS_O3.data.2eda19ca.js","fDYMP","arcgis.data.954b6a84.js","9qepU","black-marble.data.25398597.js","tWJxo","east_coast_mar_20.3d5326cb.jpg","1A5Fb","data-from-ghg.data.95bc8fe9.js","dBCIu","no2--dataset-cover.80478047.jpg","eobUZ","fire.data.bce61967.js","a06in","gedi-agb-grid-v2.1.data.9740f93f.js","cd6EH","geos-casa-gfed-cover.85410fe9.jpg","g68Z7","micasa-carbonflux-daygrid-cmr-v1.data.fcb94473.js","8kXKt","nighttime-lights--dataset-cover.1cd08e26.jpg","j98vM","nighttime-lights.data.df1e73c6.js","hfQDm","nighttime-lights--wuhan-bef-after.c0b1ed92.png","3EF1e","img-placeholder-3.4c5b2358.jpg","iOhPf","no2.data.681610d1.js","605p0","east_coast_mar_avg.6e8d4fc1.jpg","iUPog","no2-south-america.f4744577.jpg","5rMpg","img-placeholder-4.728679b2.jpg","17drc","sandbox.data.b3d919c9.js","6Zuw7","wmts-dataset.data.efcd0b92.js","5JALn","air-quality-and-covid-19--story-cover.223fafff.jpg","fhAAC","air-quality-and-covid-19.stories.3adb0f75.js","3oDQT","external-link-example.stories.aedb39fa.js","6BNEC","img-placeholder-6.88847e66.jpg","7M060","internal-link-example.stories.18bd519a.js","kUEVi","life-of-water.stories.2c201439.js","49K4r","mdx-content.7eab6f52.js","2KXMz","mdx-content.caa1e31e.js","9Clkv","xlsx.769c431a.js","dRksy","mdx-content.e6d338b6.js","UG7P6","mdx-content.ada0f9c1.js","i0wHA","mapbox-gl.8bb0fc06.js","761B6","marker-sdf.db41bce1.png","3dlTw","tour-comparison.b4c28c2d.gif","6C5XR","tour-analysis.af1a1ea4.gif","3BHPY","mdx-content.8d857f57.css","e6GlY","catalog-content.d796dad5.js","hYD2b","catalog-content.2990fd10.css","5B77q","catalog-content.80e16c0e.js","3cOKR","container.0bad5d72.js","f7Vek","mdx-content.45f0cab6.js","a4rHT","mdx-content.11e5e413.js","kvpk9","mdx-content.2a1e615d.js","9oat0","mdx-content.02967653.css","8U6bU","mdx-content.bc177153.css","Z0apu","mdx-content.a87cb750.js","4mrSc","mdx-content.9e4058f8.js","ajLG8","banner.3019b510.js","djk1t","site-alert.595dc058.js","ep2J5","cookie-consent.0dc6d222.js","gHNpg","cookie-consent.e8361d0e.js","hWkTU","cookie-consent.c0134fda.css","4eWJ5","home.5ef27fe8.js","d0fGX","root-welcome--cover.eec7a022.jpg","lrL3q","vp-01-illu.e16a91f2.png","ewJFQ","vp-02-illu.23aae56a.png","9iuDy","vp-03-illu.2016f6ab.png","jHG81","user-enthusiasts.d134e85d.jpg","bstWR","user-scientists.0f1d1c3c.jpg","5zcA7","user-researcher.a227a485.jpg","kHr0Y","about.29b8de1d.js","7W46X","development.897d2591.js","cjEyj","container.9fedbe42.js","4TUrW","container.4356526e.js","e2YKv","single.496581ae.js","gFUCA","container.f4e5ff2f.js","hVhPd","s-overview.adfda6e3.js","9CKAK","exploration.c30c707b.js","7BmCG","sandbox.441b58f1.js","47mZT","page.5ca3e429.js","bBCT7","img-placeholder-5.6262760b.jpg","9jbiS","page.d7945720.js","32qFY","chart.daa33349.js","5hzt7","aq.4cb7c0a2.csv","e69w1","two-column.ac7a3449.csv","4PfIG","sample.57667550.json","eMT70","table.16368400.js","faFis","sandbox.ad63ac69.css","etb5F","user-pages.dbe4827c.js"]'));


//# sourceMappingURL=index.runtime.53441192.js.map
